import { Link } from "react-router-dom";
import AnimatedSection from "../../../components/base/AnimatedSection";

const services = [
  {
    icon: "ri-file-list-3-line",
    title: "Gestión Administrativa",
    description: "Inscripciones, altas de jugadores, actas, calendarios y documentación completa de la competición gestionada con rigor profesional.",
  },
  {
    icon: "ri-secure-payment-line",
    title: "Gestión Fiscal y Legal",
    description: "Pagos a árbitros y colaboradores con cumplimiento tributario completo. Elimina el riesgo legal del organizador con seguridad jurídica total.",
  },
  {
    icon: "ri-whistle-line",
    title: "Coordinación de Árbitros",
    description: "Selección, asignación por jornada, comunicación, control de presencia y remuneración correcta garantizada en cada partido.",
  },
  {
    icon: "ri-team-line",
    title: "Gestión de Colaboradores",
    description: "Coordinación de anotadores, auxiliares y personal de campo. Pagos gestionados con todas las garantías legales requeridas.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Control y Trazabilidad de Pagos",
    description: "Registro completo de todos los movimientos económicos. Protección ante reclamaciones e inspecciones con transparencia total.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Soporte Operativo Continuo",
    description: "Partner permanente durante toda la temporada. Resolución de incidencias administrativas y respaldo profesional en cada jornada.",
  },
];

export default function ServicesPreview() {
  return (
    <section id="servicios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-8 h-0.5" style={{ backgroundColor: "#E8150C" }}></div>
            <span className="font-body text-brand-red text-sm font-medium tracking-widest uppercase">
              Lo que hacemos
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
            <h2 className="font-heading font-black text-brand-black leading-none"
              style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
              NUESTROS SERVICIOS
            </h2>
            <Link
              to="/servicios"
              className="font-body text-sm text-brand-red font-medium hover:underline cursor-pointer whitespace-nowrap"
            >
              Ver todos los servicios →
            </Link>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <AnimatedSection key={service.title} delay={i * 80}>
              <div className="bg-white border border-brand-pearl rounded-lg p-8 h-full group hover:border-brand-red transition-all duration-300 cursor-default">
                <div className="w-10 h-10 flex items-center justify-center mb-5">
                  <i className={`${service.icon} text-2xl text-brand-red`}></i>
                </div>
                <h3 className="font-heading font-bold text-brand-black text-xl mb-3 tracking-tight">
                  {service.title}
                </h3>
                <p className="font-body text-brand-gray-mid text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={200}>
          <div className="flex justify-center mt-14">
            <Link
              to="/servicios"
              className="bg-brand-red hover:bg-brand-red-hover text-white font-body font-medium px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              Solicitar información
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}